<script lang="ts">
export interface PaginationProps extends ClassProps {
	hasMore?: boolean;
	defaultPage?: number;
}
</script>
<script setup lang="ts">
import { mdiChevronDoubleLeft, mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import { type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import Button from "../button/Button.vue";
import Icon from "../icon/Icon.vue";

const props = withDefaults(defineProps<PaginationProps>(), {
	hasMore: true,
	defaultPage: 1,
});

const page = defineModel<number>("page", { default: (p) => p.defaultPage });
</script>

<template>
	<div :class="cn('text-base-content flex items-center gap-1', props.class)">
		<Button variant="ghost" size="sm" :disabled="page === 1" @click="page = 1">
			<Icon :d="mdiChevronDoubleLeft" />
		</Button>

		<Button variant="ghost" size="sm" :disabled="page === 1" @click="page--">
			<Icon :d="mdiChevronLeft" />
		</Button>

		<Button class="btn-active" color="neutral" size="sm" variant="soft">
			{{ page }}
		</Button>

		<Button variant="ghost" size="sm" :disabled="!hasMore" @click="page++">
			<Icon :d="mdiChevronRight" />
		</Button>
	</div>
</template>
